import { render, staticRenderFns } from "./file-image.app.vue?vue&type=template&id=13c34117&"
import script from "./file-image.app.vue?vue&type=script&lang=js&"
export * from "./file-image.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports